// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import * as z from 'zod';
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { projectCostSchema } from '@/project/api/types';

const getProjectCostResponseSchema = z.object({
  data: z.array(projectCostSchema),
  metadata: responseMetadataSchema,
});

type GetProjectCostResponse = z.infer<typeof getProjectCostResponseSchema>;

export async function getProjectCosts(
  projectKey: string
): Promise<GetProjectCostResponse> {
  const url = `/v1/project/${projectKey}/costs`;
  const response = await api.get(url);

  return parseResponse(getProjectCostResponseSchema, response.data, {
    schemaName: 'ProjectCosts',
    endpoint: url,
  });
}
